import { render } from "./honoreeGrid.vue?vue&type=template&id=2958fab8&scoped=true"
import script from "./honoreeGrid.vue?vue&type=script&lang=js"
export * from "./honoreeGrid.vue?vue&type=script&lang=js"

import "./honoreeGrid.vue?vue&type=style&index=0&id=2958fab8&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2958fab8"]])

export default __exports__